"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
const bridge_1 = require("@completeanatomy/bridge");
const InfoBoxStateProvider_1 = require("../../providers/InfoBoxStateProvider");
const device_1 = require("@completeanatomy/device");
const useInfoBoxStateReducer_1 = require("../../hooks/useInfoBoxStateReducer");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const i18n_1 = require("@completeanatomy/i18n");
function MultiSelectionItemCard({ className, name, latinName, onClick, children, identifier, index, isSelected, showDeleteButton = true, isGrasshopper = false, }, ref) {
    const { isMobile } = (0, device_1.usePlatform)();
    const { t } = (0, i18n_1.useTranslation)();
    const bridge = (0, bridge_1.useBridge)();
    const [{ isExpandedItem }, dispatch] = (0, InfoBoxStateProvider_1.useInfoBoxStateContext)();
    const onClickInternal = () => {
        if (!isGrasshopper) {
            bridge === null || bridge === void 0 ? void 0 : bridge.selectInfoBoxListItem({
                type: bridge_schema_1.InfoBoxTabType.MultiSelect,
                index,
                identifier,
            });
        }
        onClick();
    };
    const onDelete = (e) => {
        e.stopPropagation();
        dispatch((0, useInfoBoxStateReducer_1.expandItem)(false));
        bridge === null || bridge === void 0 ? void 0 : bridge.removePartFromSelection({
            identifier,
            type: bridge_schema_1.InfoBoxTabType.MultiSelect,
        });
    };
    return ((0, jsx_runtime_1.jsxs)(Container, { ref: ref, className: className, role: "listitem", "data-e2e": 'MultiSelectionItemCard_Container', children: [(0, jsx_runtime_1.jsx)(TopContainer, { "data-e2e": 'MultiSelectionItemCard_TopContainer', children: (0, jsx_runtime_1.jsxs)(InfoContainer, { "data-e2e": 'MultiSelectionItemCard_InfoContainer', children: [(0, jsx_runtime_1.jsxs)(LeftSide, { "$selected": isSelected, onClick: onClickInternal, role: "button", "aria-selected": isSelected, "data-e2e": 'MultiSelectionItemCard_LeftSide', children: [(0, jsx_runtime_1.jsx)(Title, { "$isMobile": isMobile, "$selected": isSelected, "data-e2e": 'MultiSelectionItemCard_Title', children: name }), latinName && ((0, jsx_runtime_1.jsx)(Subtitle, { "$isMobile": isMobile, "$selected": isSelected, "data-e2e": 'MultiSelectionItemCard_Subtitle', children: latinName }))] }), (0, jsx_runtime_1.jsx)(RightSide, { "data-e2e": 'MultiSelectionItemCard_RightSide', children: showDeleteButton && ((0, jsx_runtime_1.jsx)(DeleteButton, { onClick: onDelete, "aria-label": t(i18n_1.Strings.common.delete), "data-e2e": 'MultiSelectionItemCard_DeleteButton', children: (0, jsx_runtime_1.jsx)(StyledIcon, { name: ui_1.Icons.Clear, width: 18, height: 18, "data-e2e": 'MultiSelectionItemCard_StyledIcon' }) })) })] }) }), isSelected && isExpandedItem && children] }));
}
exports.default = (0, react_1.forwardRef)(MultiSelectionItemCard);
const Container = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  flex-shrink: 0;

  padding: 5px 8px;

  cursor: pointer;
`;
const DeleteButton = styled_components_1.default.button `
  margin: 0;
  padding: 0;

  background-color: transparent;
  border: none;
  visibility: hidden;
  cursor: pointer;
  opacity: 0;

  transition: opacity 0.25s;

  &:focus {
    outline: none;
  }
`;
const TopContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;

  &:hover {
    ${DeleteButton} {
      visibility: visible;
      opacity: 1;
    }
  }
`;
const InfoContainer = styled_components_1.default.div `
  display: flex;
  flex-grow: 1;
`;
const LeftSide = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  color: ${({ $selected, theme }) => $selected ? theme.text : theme.textSecondary};
  font-weight: ${({ $selected }) => ($selected ? 'bold' : 'normal')};
`;
const RightSide = styled_components_1.default.div `
  display: flex;
  align-items: center;
`;
const StyledIcon = (0, styled_components_1.default)(ui_1.Icon) `
  color: ${({ theme }) => theme.disabledSecondary};
`;
const Title = styled_components_1.default.h5 `
  margin: 0;

  font-weight: ${({ $selected }) => ($selected ? 'bold' : 'normal')};
  font-size: ${({ $isMobile, $selected }) => $isMobile ? 16 : $selected ? 17.5 : 16.5}px;
`;
const Subtitle = styled_components_1.default.h6 `
  margin: 0;

  font-weight: ${({ $isMobile }) => ($isMobile ? 300 : 'inherit')};
  font-size: ${({ $isMobile, $selected }) => $isMobile ? 13.5 : $selected ? 14 : 12}px;
`;
